/**
 * A pair of buttons with login and signup CTAs
 */
import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";

type Props = {
    disabled?: boolean;
    onLoginClick: () => unknown;
    onSignupClick: () => unknown;
};

export default ({
    disabled,
    onLoginClick,
    onSignupClick,
}: Props): React.ReactElement => (
    <View>
        <Button
            disabled={disabled}
            onClick={onSignupClick}
            testId="create-account-button"
        >
            {t`Create a new account`}
        </Button>
        <View style={styles.shim8} />
        <Button
            disabled={disabled}
            kind="secondary"
            onClick={onLoginClick}
            testId="log-in-to-existing-account"
        >
            {t`Log in to your existing account`}
        </Button>
    </View>
);

const styles = StyleSheet.create({
    shim8: {
        height: 8,
    },
});
